import fetch from '../utils/fetch'


/******宣传连接**********/
export function getPublicity (query) {
  return fetch({
    url: '/publicity/links',
    method: 'get',
    params: query
  })
}
export function addPublicity (params) {
  return fetch({
    url: '/publicity/links',
    method: 'post',
    data: params
  })
}
export function updatePublicity (id,query) {
  return fetch({
    url: '/publicity/links/' + id,
    method: 'put',
    data: query
  })
}
export function deletePublicity (id) {
  return fetch({
    url: '/publicity/links/' + id,
    method: 'delete'
  })
}
//   宣传吗
export function getQrcodes (query) {
  return fetch({
    url: '/publicity/qrcode',
    method: 'get',
    params: query
  })
}
// http://ddps.yaoking.cn/api
export function addQrcodes (params) {
  return fetch({
      url: 'http://ddps.yaoking.cn/api/publicity/qrcode',
    //url: '/publicity/qrcode',
    method: 'post',
    data: params
  })
}
export function updateQrcodes (query) {
  return fetch({
    url: '/publicity/qrcode/batch',
    method: 'put',
    data: query
  })
}
export function updateOneData (query) {
  return fetch({
    url: '/publicity/qrcode',
    method: 'put',
    data: query
  })
}
// https://ddps.yaoking.cn/api
export function expDataApi (query) {
  return fetch({
    url: 'http://ddps.yaoking.cn/api/publicity/qrcode/exp',
    method: 'get',
    params: query
  })
}
export function getQrcodesMember (query) {
  return fetch({
    url: '/publicity/qrcode/members',
    method: 'get',
    params: query
  })
}
export function getQrcodesMemberLog (query) {
  return fetch({
    url: '/publicity/qrcode/members/log',
    method: 'get',
    params: query
  })
}
export function qrcodeDownload(query){
  return fetch({
    url: 'http://ddps.yaoking.cn/api/publicity/qrcode/download',
    method: 'get',
    params: query
  })
}
//  同步七牛云
export function qrcodeSynchro(query){
  return fetch({
    url: '/publicity/qrcode/synchro',
    method: 'get',
    params: query
  })
}
/******updateOneData**********/



// WEBPACK FOOTER //
// ./src/api/publicity.js